import { FetchParams, SortDirection } from "@nt-portal/common-sdk";
import { AppSettings, getAppSettings } from "../../hooks/settings/settings";
import { ControllerOptions, DataController } from "../../types";
import { ApiService } from "../api-service";
import { initAppSetting } from "../../redux/settings-slice";


export class BaseClientService {
    private _settings: AppSettings = { ...initAppSetting };

    protected get token() {
        return "";
    }

    protected get settings() {
        return this._settings;
    }

    


    private _apiService: ApiService;

    protected get apiService() {
        return this._apiService
    }

    public onProgress?: (value: number) => void;

    constructor() {
        this._settings = getAppSettings();
        this._apiService = new ApiService();
        this._apiService.onProgress = (value) => {
            if (this.onProgress)
                this.onProgress(value)
        }
    }

    protected buildLookupFetchParams<T>(options: ControllerOptions<T>) {

        let sortOrder = options.params?.sortOrder === -1 ?   SortDirection.DESC : SortDirection.ASC;
        
        let fetchParams = new FetchParams();
        fetchParams.limit = -1;
        fetchParams.skip = 0;
        fetchParams.orderBy = options.params ? options.params.sortField : "name"
        fetchParams.orderDir = sortOrder;
        return fetchParams;
    }


    protected buildFetchParams<T>(options: ControllerOptions<T>) {
        let params = options.params;
        if (params) {
            let fetchParams = new FetchParams();
            fetchParams.limit = params.rows ?? -1;
            fetchParams.skip = params?.page && params.rows ? params.page * params.rows : 0;
            fetchParams.orderBy = params.sortField;
            fetchParams.orderDir = params.sortOrder === -1 ? SortDirection.DESC : SortDirection.ASC;
            return fetchParams;
        } else {
            let fetchParams = new FetchParams();
            fetchParams.limit = 10;
            fetchParams.skip = 0;
            fetchParams.orderBy = '';
            fetchParams.orderDir = SortDirection.ASC;
            return fetchParams;
        }
    }


}